import DiemDanhDetailModal from "./DiemDanhDetailModal";

export default DiemDanhDetailModal